import { createFileRoute, useRouterState } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { BannersPlacement } from "@/components/BannersPlacement/BannersPlacement";
import { Button } from "@/components/Button";
import { Footer } from "@/components/Footer/Footer";
import { FlightSearchForm } from "@/features/flights/components/FlightSearchForm/FlightSearchForm";
import { useFlightSearchForm } from "@/features/flights/hooks/flightSearch/useFlightSearchForm";
import type { FlightSearchFormValues } from "@/features/flights/utils/flightsValidation";
import { SearchCategorySwitcher } from "@/features/search/components/SearchCategorySwitcher";
import { BannersPlacementSlug } from "@/types/enums";

export const Route = createFileRoute("/_authenticated/flights/search")({
  component: RouteComponent,
});

function RouteComponent() {
  const intl = useIntl();

  const navigate = Route.useNavigate();
  const state = useRouterState({ select: (s) => s.location.state });

  const { handleSubmit: handleFlightSearchFormSubmit } = useFlightSearchForm();

  const handleFlightSearchSubmit = (values: FlightSearchFormValues) => {
    handleFlightSearchFormSubmit(values);
    navigate({ to: "/flights/departure/list" });
  };

  return (
    <main className="main">
      <div className="w-full space-y-3 p-main">
        <SearchCategorySwitcher current="flights" />

        <div className="rounded-4xl bg-surface-base-light p-4 shadow-md">
          <FlightSearchForm
            initialValues={state.flightSearchPrefill ?? null}
            submitButton={
              <div className="mt-2">
                <Button fullWidth variant="contained" type="submit">
                  {intl.formatMessage({
                    defaultMessage: "Search flight",
                    description:
                      "Search flights submit button label in the flight search form",
                  })}
                </Button>
              </div>
            }
            analyticsSource="main"
            onSubmit={handleFlightSearchSubmit}
          />
        </div>

        <BannersPlacement slug={BannersPlacementSlug.FLIGHT_PAGE_SLOT_1} />
        <BannersPlacement slug={BannersPlacementSlug.FLIGHT_PAGE_SLOT_2} />
        <BannersPlacement slug={BannersPlacementSlug.FLIGHT_PAGE_SLOT_3} />
      </div>

      <Footer />
    </main>
  );
}
